window.DateRangePicker = {

    init: function(target, autosubmit){
        autosubmit = undefined === autosubmit ? true : autosubmit;

        $.datepicker._defaults.onAfterUpdate = null;
        var datepicker__updateDatepicker = $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function( inst ) {
            datepicker__updateDatepicker.call( this, inst );
            var onAfterUpdate = this._get(inst, 'onAfterUpdate');
            if (onAfterUpdate)
                onAfterUpdate.apply((inst.input ? inst.input[0] : null),
                    [(inst.input ? inst.input.val() : ''), inst]);
        }

        var cur = -1, prv = -1;
		var $container	= $('.daterangepicker');
		var $render		= $('div', $container);
		var $input		= $('input', $container);
		var date_format, min_date;
		
		// Getting date format from HTML attribute
		switch($input.attr('format')){
			case 'mdy':
				
				date_format = 'mm/dd/yy';
				break;
				
			case 'dmy':
			default:
				
				date_format = 'dd/mm/yy';
				break;
		}
		
		// Getting minimal date from HTML attribute
		if(!_.isUndefined($input.attr('min'))){
			
			// Real month = (month - 1), https://www.w3schools.com/jsref/jsref_obj_date.asp
			var date	= $input.attr('min').split('-');
			min_date	= new Date(date[0], (date[1] - 1), date[2]);
		}
		
		var options = {
            numberOfMonths: 2,
			
            // changeMonth: true,
            // changeYear: true,
            showButtonPanel: false,
            beforeShowDay: function ( date ) {
				
                var firstDate = Math.min(cur, prv);
                if(date.getTime() == cur){
                    if(firstDate == cur){
                        return [true, 'date-range-selected date-range-currentSelected date-range-first'];
                    } else{
                        return [true, 'date-range-selected date-range-currentSelected date-range-last'];
                    }
                }
				
                if(date.getTime() == prv){
                    if(firstDate == prv){
                        return [true, 'date-range-selected date-range-currentSelected date-range-first'];
                    } else{
                        return [true, 'date-range-selected date-range-currentSelected date-range-last'];
                    }
                }
				
                if(date.getTime() >= Math.min(prv, cur) && date.getTime() <= Math.max(prv, cur)){
                    return [true, 'date-range-selected'];
                }

                return [true, ''];
            },
            onSelect: function ( dateText, inst ) {
				
                var d1, d2;
                prv = cur;
                cur = (new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay)).getTime();
				
                if ( prv == -1 || prv == cur ) {
					
                    prv = cur;
                    $input.val( dateText );
                } else {
					
                    d1 = $.datepicker.formatDate( date_format, new Date(Math.min(prv,cur)), {} );
                    d2 = $.datepicker.formatDate( date_format, new Date(Math.max(prv,cur)), {} );
                    $input.val( d1+' - '+d2 );
                }
            },
            onChangeMonthYear: function ( year, month, inst ) {
                //prv = cur = -1;
            },
            onAfterUpdate: function ( inst ) {
				
                var apply       = Loc.g('Appliquer');
                var cancel      = Loc.g('Annuler');
                var callback    = "$('"+target+"').submit();MyFacture.startWait();"
                if(!autosubmit){
                    callback    = ""
                }
                $('<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all btn btn-primary fright m-2" data-handler="hide" data-event="click" onclick="'+callback+'">'+apply+'</button>' +
                    '<button type="button" class="ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all btn btn-default fright m-2" data-handler="hide" data-event="click">'+cancel+'</button>')
                    .appendTo($('.daterangepicker div .ui-datepicker'))
                    .on('click', function () { $render.hide(); });
            }
        };
		
		if(min_date){
			options.minDate = min_date;
		}
		
        $render.datepicker(options).position({
			my: 'left top',
			at: 'left bottom',
			of: $input
		}).hide();

        $input.on('focus', function (e) {
            var v = this.value,
                d;
				
            try {

                if ( v.indexOf(' - ') > -1 ) {
                    d = v.split(' - ');
                    prv = $.datepicker.parseDate( date_format, d[0] ).getTime();
                    cur = $.datepicker.parseDate( date_format, d[1] ).getTime();
                } else if ( v.length > 0 ) {
                    prv = cur = $.datepicker.parseDate( date_format, v ).getTime();
                }
				
                var lang		= $(this).attr('lang');
                $.datepicker.setDefaults($.datepicker.regional[lang]);

            } catch ( e ) {
                cur = prv = -1;
            }
			
            if ( cur > -1 )
                $render.datepicker('setDate', new Date(cur));
            $render.datepicker('refresh').show();
        });
    }
};